import { useTranslation } from 'react-i18next'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog'
import type { ResolutionBand } from '@/services/api/entity-resolution-assistant'
import { bulkEligibleGroups } from './resolution-identity'

interface ConfirmationActions {
  open: boolean
  setOpen: (open: boolean) => void
  confirm: () => void
}

export function ResolutionMergeConfirmation({
  bands,
  actions,
}: {
  bands: ResolutionBand[]
  actions: ConfirmationActions
}) {
  const { t } = useTranslation()
  const groups = bands.reduce((sum, band) => sum + bulkEligibleGroups(band), 0)
  const ranges = bands.map(band => t(`resolutionAssistant.bands.${band.id}`)).join(', ')
  return (
    <AlertDialog open={actions.open} onOpenChange={actions.setOpen}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t('resolutionAssistant.confirmTitle', { count: groups })}
          </AlertDialogTitle>
          <AlertDialogDescription>
            {t('resolutionAssistant.confirmDescription', { ranges })}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <p className="text-sm text-muted-foreground">{t('resolutionAssistant.confirmAudit')}</p>
        <AlertDialogFooter>
          <AlertDialogCancel>{t('common.cancel')}</AlertDialogCancel>
          <AlertDialogAction onClick={actions.confirm}>
            {t('resolutionAssistant.confirmMerge')}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  )
}
